export default [
    {
        path: '/hospital/doctor-schedule/:appId',
        name: 'doctor-schedule',
        component: () => import('@/numberPortal/views/hospital/doctorSchedule/index.vue'),
        meta: {
            icon: 'fa fa-calendar-plus-o',
            title: '医生排班',
        },
    },
    {
        path: '/hospital/appointment/:appId',
        name: 'doctor-schedule',
        component: () => import('@/numberPortal/views/hospital/appointment/index.vue'),
        meta: {
            icon: 'fa fa-calendar-plus-o',
            title: '预约挂号',
        },
    },
    {
        path: '/hospital/appointment/:appId/:recordId',
        name: 'doctor-schedule',
        component: () => import('@/numberPortal/views/hospital/appointmentRecord/index.vue'),
        meta: {
            parent: `/hospital/appointment/192997`,
            icon: 'fa fa-calendar-plus-o',
            title: '详情',
        },
    },
];
